<template>
  <div>
    <div class="wrap">

    </div><button @click="clearData">清除缓存</button>
    <div>
      {{user}}
    </div>


  </div>
</template>
<script>
import loginService from '../plugin/extendFn/loginService';
  import store from "../store";

  export default {
    data() {
      return {
        user:'',
      }
    },
    props: {},
    methods: {
      clearData(){
        localStorage.clear();
        loginService.logout();
      }
    },
    computed: {},
    mounted() {
      this.user = localStorage.getItem('user')||'沒有數據';
    }
  }
</script>
<style scoped lang="scss">
  .wrap{
    padding-top: 3rem;
  }
  button{
    width: 4rem;
    height: 4rem;
    color: #ffffff;
    background:#000000;
    border-radius: 50%;
    outline: none;
    font-size: .32rem;
    display: block;
    margin: auto auto;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/clear.vue